import { useContext, useEffect, useState } from "react"
import { Box, Typography } from "@mui/material"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import OneModal from "../../Components/OneModal/OneModal"

const ImgEvento = ({ evento }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const [imgs, setImgs] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [urlImg, setUrlImg] = useState('')
    const [imgName, setImgName] = useState('')

    const urlWsOne = window.location.origin.replace(':3003', '') + `/wsOnePortaria/dados/eventos/${evento.id_one_log}`

    useEffect(() => {
        if (evento.id) {
            addRoute('getImagesByEvent', getImagesByEvent)
            sendWs('getImagesByEvent', { id: evento.id_one_log })
        }
    }, [evento])

    const getImagesByEvent = (msg) => {
        const { status, dados } = msg.data

        if (status && dados.length > 0) {
            setImgs(dados)
        }
    }

    const handleModal = (nameimg, urlimg) => {
        setImgName(nameimg)
        setUrlImg(urlimg)
        setOpenModal(true)
    }

    return (
        <Box sx={{ backgroundColor: '#D9D9D9', maxHeight: '100%', height: '100%', overflowY: 'scroll' }}>
            <OneModal
                open={openModal}
                setOpen={setOpenModal}
                titleText={imgName}
                fullWidth={true}
                maxWidth='xl'
                paddingZero={true}
            >
                <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={urlImg} style={{ borderRadius: '10px', maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto' }}></img>
                </Box>
            </OneModal>

            <Box component='div' sx={{ display: "flex", justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                {
                    imgs && imgs.length > 0
                        ? imgs.map((img_, i) => {
                            const urlimg = `${urlWsOne}/${img_}`
                            return (
                                <Box key={i} onClick={() => { handleModal(img_, urlimg) }} sx={{ maxWidth: '100%', maxHeight: '100%', border: '2px solid white', borderRadius: '10px', padding: 0, margin: 0, cursor: 'pointer' }}>
                                    <img src={urlimg} style={{ borderRadius: '10px', maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto' }}></img>
                                </Box>
                            )
                        })
                        : <Typography sx={{ color: 'black', fontSize: '16px', fontWeight: 'bold', marginTop: '10px' }}>Imagem indisponível!</Typography>
                }
            </Box>
        </Box>
    )
}

export default ImgEvento
